import { chain } from '@leprecoins/effector';
import { combine, createEvent, createStore, sample } from 'effector';
import { createGetGamesCashierQuery } from 'shared/api';

const getGamesCashierQuery = createGetGamesCashierQuery();

const $games = getGamesCashierQuery.$data.map((result) => result?.rows ?? []);

const $activeGame = createStore<number | null>(null);

const $gameName = combine(
	{
		gameId: $activeGame,
		games: $games,
	},
	({ gameId, games }) => games.find((game) => Number(game.id) === gameId)?.title ?? '',
);

const { $pending } = getGamesCashierQuery;

const setActiveGame = createEvent<number | null>();

chain(setActiveGame, $activeGame);

sample({
	clock: getGamesCashierQuery.finished.success,
	fn: ({ result }) => result.rows[0]?.id,
	target: $activeGame,
});

export const gameAsideModel = {
	$games,
	$activeGame,
	$gameName,
	$pending,
	setActiveGame,
	getGamesCashierQuery,
};
